import { render, staticRenderFns } from "./ThisWeek.vue?vue&type=template&id=03da8a2b&"
import script from "./ThisWeek.vue?vue&type=script&lang=ts&"
export * from "./ThisWeek.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports